import { render, staticRenderFns } from "./ProfileWise.vue?vue&type=template&id=4a328def&scoped=true&"
import script from "./ProfileWise.vue?vue&type=script&lang=js&"
export * from "./ProfileWise.vue?vue&type=script&lang=js&"
import style0 from "./ProfileWise.vue?vue&type=style&index=0&id=4a328def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a328def",
  null
  
)

export default component.exports